import { StandardEvents } from '@shopify/events';
const link = document.querySelector('[data-sl-cart-link]');
const renderCount = value => {
  if (!link || !Number.isFinite(value)) return;
  const count = Math.max(0, value);
  const badge = link.querySelector('[data-sl-cart-count]');
  if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
  link.setAttribute('aria-label', `購物車，目前 ${count} 件商品`);
};
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({cart, detail}) => renderCount(cart?.totalQuantity ?? detail?.itemCount)).catch(() => {});
});
window.addEventListener('pageshow', event => {
  if (!event.persisted || !link) return;
  fetch(`${link.dataset.cartUrl}.js`, {headers: {Accept: 'application/json'}})
    .then(response => response.ok ? response.json() : null)
    .then(cart => { if (cart) renderCount(cart.item_count); }).catch(() => {});
});
